import { useSelector } from 'react-redux';

import { selectors as AuthLogicSelectors } from 'ha/modules/AuthLogic';

import { SubscriptionFeeRuleName } from './constants';

export function useBillingSubscription(tenantFeeRuleName: string) {
  const hasConversationAccessSubscription = useSelector(
    AuthLogicSelectors.hasConversationAccessSubscription,
  );

  const billingSubscriptionEnabled =
    tenantFeeRuleName === SubscriptionFeeRuleName;

  return {
    billingSubscriptionEnabled,
    hasConversationAccessSubscription,
  };
}
